import React from "react";

const BanUser = (props) => {
  return <div>BanUser</div>;
};

export default React.memo(BanUser);
